// extracted by mini-css-extract-plugin
module.exports = {"phone":"PhoneContainer_phone__2F388","load":"PhoneContainer_load__aeRKK","persp":"PhoneContainer_persp__h0zWH","video":"PhoneContainer_video__2MTPg"};